import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  InputProps,
} from "@chakra-ui/react";
import { useController, Control, FieldValues, Path } from "react-hook-form";

interface FormTimeInputProps<T extends FieldValues>
  extends Omit<InputProps, "name"> {
  name: Path<T>;
  label: string;
  control: Control<T, any, any>;
  isRequired?: boolean;
}

export function FormTimeInput<T extends FieldValues>({
  name,
  label,
  control,
  isRequired = false,
  ...inputProps
}: FormTimeInputProps<T>) {
  const {
    field: { onChange, ...field },
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    // Ensure the value is in HH:mm format
    if (/^\d{2}:\d{2}$/.test(value)) {
      onChange(value.replace(/(\d{2}):(\d{2})/, "$1:$2")); // Format to HH:mm
    } else {
      onChange(""); // Reset if invalid format
    }
  };

  return (
    <FormControl isInvalid={!!error} isRequired={isRequired}>
      <FormLabel>{label}</FormLabel>
      <Input type="time" onChange={handleChange} {...field} {...inputProps} />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </FormControl>
  );
}
